import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { MessageBroadcastingService } from '../message-broadcasting.service';
import { Subject, Subscription } from 'rxjs';
import { AuthService } from '../../core/security/auth.service';
import { Router } from '@angular/router';
import { BroadcastThreadViewModel } from '../../api/models';
import { BroadcastPhoneNumberGroupDatasource } from './broadcast-phone-number-group.datasource';
import { debounceTime } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { LocalNotificationsService } from '../../core/services/local-notifications.service';
import { MatSelectionList, MatListOption } from '@angular/material/list';
import { CdkVirtualScrollViewport, CdkFixedSizeVirtualScroll, CdkVirtualForOf } from '@angular/cdk/scrolling';
import { BroadcastPhoneNumberGroupItemComponent } from '../phone-number-group-item/broadcast-phone-number-group-item.component';

@Component({
    selector: 'app-broadcast-phone-number-group',
    template: `
    <mat-selection-list class="thread-list" [multiple]="false" [hideSingleSelectionIndicator]="true">
      <cdk-virtual-scroll-viewport itemSize="99" class="thread-viewport">
        <mat-list-option
          *cdkVirtualFor="let item of dataSource"
          [selected]="item?.id === selectedBroadcastId"
          (click)="onRowClick($event, item)">
          <app-broadcast-phone-number-group-item
            [dataItem]="item"
            [searchText]="searchText"
          ></app-broadcast-phone-number-group-item>
        </mat-list-option>
      </cdk-virtual-scroll-viewport>
    </mat-selection-list>
  `,
    styles: [],
    standalone: true,
    imports: [
        MatSelectionList,
        CdkVirtualScrollViewport,
        CdkFixedSizeVirtualScroll,
        CdkVirtualForOf,
        MatListOption,
        BroadcastPhoneNumberGroupItemComponent,
    ],
})
export class BroadcastPhoneNumberGroupComponent implements OnInit, OnDestroy, OnChanges {
  private readonly TAG = 'BroadcastPhoneNumberGroupComponent:';

  @Input() selectedNumber: string;
  @Input() selectedBroadcastId: string;
  @Input() searchText: string;
  @Output() selectedThreadChangeEvent = new EventEmitter<BroadcastThreadViewModel>();

  onWebSocketConnectSubscription: Subscription;
  dataSourceSubject = new Subject();
  dataSourceSubscription: Subscription;

  constructor(
    public messagingService: MessageBroadcastingService,
    public authService: AuthService,
    public notificationsService: LocalNotificationsService,
    public dataSource: BroadcastPhoneNumberGroupDatasource,
    private router: Router,
    public dialog: MatDialog,
  ) {
    this.dataSource.selectedThreadChangeEvent.subscribe(data => {
      console.log(`${this.TAG} selectedThreadChangeEvent`, data);
      this.selectedThreadChangeEvent.emit(data);
    });
  }

  ngOnInit() {
    console.log(`${this.TAG} init`);

    this.onWebSocketConnectSubscription = this.messagingService.onWebSocketConnectSubject.subscribe(() => {
      this.dataSourceSubject.next('');
    });

    this.dataSourceSubscription = this.dataSourceSubject.pipe(debounceTime(100)).subscribe(value => {
      this.filterData();
    });

    this.filterData();
  }

  filterData() {
    this.dataSource.onFilterDataChanged({
      phoneNumber: this.selectedNumber,
      searchText: this.searchText,
      broadcastId: this.selectedBroadcastId,
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(`${this.TAG} ngOnChanges`, changes);
    this.dataSourceSubject.next('');
  }

  async forceRefresh() {
    await this.dataSource.resetData();
  }

  onRowClick(event, dataItem: BroadcastThreadViewModel) {
    console.log(`${this.TAG} onRowClick`, dataItem);

    this.router
      .navigate([], { queryParams: { tn: this.selectedNumber, broadcast: dataItem.id } })
      .catch(error => console.log(`${this.TAG} route`, error));

  }

  ngOnDestroy() {
    this.onWebSocketConnectSubscription?.unsubscribe();
    this.dataSourceSubscription?.unsubscribe();
  }
}
